export const CertificateData = [
  // {
  //   id: 1,
  //   title: "Oracle Cloud Infrastructure Foundations",
  //   issuer: "Oracle",
  //   date: "2023",
  //   credential: "OCI-F-2023",
  //   category: "Cloud",
  //   color: "#C74634",
  //   icon: "./icon/OCI.png",
  //   imgURL: "./certificates/oci.png", // add your image to public/certificates/
  // },
  // {
  //   id: 2,
  //   title: "AWS Cloud Practitioner",
  //   issuer: "Amazon Web Services",
  //   date: "2023",
  //   credential: "AWS-CP-2023",
  //   category: "Cloud",
  //   color: "#FF9900",
  //   icon: "./icon/aws.png",
  //   imgURL: "./certificates/aws.png",
  // },
  // {
  //   id: 3,
  //   title: "React Developer Certification",
  //   issuer: "Meta",
  //   date: "2022",
  //   credential: "META-REACT-2022",
  //   category: "Frontend",
  //   color: "#61DAFB",
  //   icon: "./icon/reactjs.png",
  //   imgURL: "./certificates/react.png",
  // },
  // {
  //   id: 4,
  //   title: "Node.js Application Developer",
  //   issuer: "OpenJS Foundation",
  //   date: "2022",
  //   credential: "OPENJS-NODE-2022",
  //   category: "Backend",
  //   color: "#339933",
  //   icon: "./icon/nodejs.png",
  //   imgURL: "./certificates/nodejs.png",
  // },
  {
    id: 3,
    title: "AI For Everyone",
    issuer: "DeepLearning.AI",
    date: "2026",
    credential: "FCC-FS-2020",
    category: "AI Technology",
    color: "#ff5e00",
    imgURL: "./certificates/ai.png",
  },
  {
    id: 4,
    title: "AWS Cloud Technical Essentials",
    issuer: "AWS",
    date: "2026",
    credential: "FCC-FS-2020",
    category: "Cloud",
    color: "#ffae00",
    imgURL: "./certificates/aws.png",
  },
  {
    id: 5,
    title: "Python for Data Science, AI & Development",
    issuer: "IBM",
    date: "2025",
    credential: "HLKIZWYW05JS",
    category: "Backend",
    color: "#3776AB",
    // type: "pdf",
    imgURL: "./certificates/python.png",
    verifyURL: "https://www.coursera.org/verify/HLKIZWYW05JS",
  },
  {
    id: 6,
    title: "Foundations of Cyber Security",
    issuer: "Google",
    date: "2026",
    credential: "FCC-FS-2020",
    category: "Cyber Security",
    color: "#0A0A23",
    imgURL: "./certificates/cyber_security.png",
  },
  
];

export const CertificateCategories = ["All", "Cloud", "AI Technology", "Backend", "Cyber Security"];
